<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M8.25 3H3.875C3.35 3 3 3.35 3 3.875V8.25C3 8.775 3.35 9.125 3.875 9.125H8.25C8.775 9.125 9.125 8.775 9.125 8.25V3.875C9.125 3.35 8.775 3 8.25 3Z"
      fill="currentColor"
    />
    <path
      d="M16.125 3H11.75C11.225 3 10.875 3.35 10.875 3.875V8.25C10.875 8.775 11.225 9.125 11.75 9.125H16.125C16.65 9.125 17 8.775 17 8.25V3.875C17 3.35 16.65 3 16.125 3Z"
      fill="currentColor"
    />
    <path
      d="M8.25 10.8749H3.875C3.35 10.8749 3 11.2249 3 11.7499V16.1249C3 16.6499 3.35 16.9999 3.875 16.9999H8.25C8.775 16.9999 9.125 16.6499 9.125 16.1249V11.7499C9.125 11.2249 8.775 10.8749 8.25 10.8749Z"
      fill="currentColor"
    />
    <path
      d="M16.125 10.8749H11.75C11.225 10.8749 10.875 11.2249 10.875 11.7499V16.1249C10.875 16.6499 11.225 16.9999 11.75 16.9999H16.125C16.65 16.9999 17 16.6499 17 16.1249V11.7499C17 11.2249 16.65 10.8749 16.125 10.8749Z"
      fill="currentColor"
    />
  </svg>
</template>
